export default __webpack_public_path__ + "static/media/2.1a1b8f56.jpeg";